import { render } from "./KitchenDivisionView.vue?vue&type=template&id=08ed9092"
import script from "./KitchenDivisionView.vue?vue&type=script&lang=js"
export * from "./KitchenDivisionView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__